import { call } from '../@';

export default async function resetPassword(email: string) {
	return call('auth-resetPassword', { email });
}
